module.exports = __webpack_public_path__ + "img/deddc0b.svg";